/* src/app/components/analytics/search-report/search-reports/search-reports.component.scss */
table {
  width: 100%;
}
.left-column {
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  flex-grow: 1;
  max-width: 400px;
  margin-top: 20px;
  width: 100%;
}
.right-column {
  display: flex;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.card-container {
  justify-content: space-evenly;
  overflow: auto;
  width: 100%;
  margin-top: -40px;
}
.add-report-button {
  margin-bottom: 10px;
  margin-left: 45px;
  z-index: 10;
  margin-top: -10px;
}
.filter-string {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.54);
}
:host-context(.dark-theme) .filter-string {
  color: #cbcbcb;
}
.info-text {
  color: rgba(0, 0, 0, 0.54);
}
:host-context(.dark-theme) .info-text {
  color: #cbcbcb;
}
.unstyled-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-align: inherit;
  cursor: pointer;
  outline: none;
  appearance: none;
}
/*# sourceMappingURL=search-reports.component.css.map */
